import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useLoginContext } from "../../../App";
import { getIndicatorLevelNs, getLevelNImagePathWithAPIKey } from "../../../services/b2b-frameworks-apiService";
import useB2BTranslation from "../../b2b-common/hooks/useB2BTranslation";
import { showNotification } from "../../b2b-common/Notification";
import { useContentContext } from "../../layout/Layout";
import { getParentLevelNsIds } from "../components/helper";

const useIndicatorImpact = (frameworkSuite, frameworkId, indicatorUUID, imageLabel = null) => {
    const { loginData } = useLoginContext();
    const { setNotification } = useContentContext();
    const { t } = useB2BTranslation('b2b-frameworks');
    const queryClient = useQueryClient();

    // console.log('useIndicatorImpact', frameworkSuite, frameworkId, indicatorUUID);

    const fetchIndicatorImpact = async () => {
        const { accessToken, loggedOrganizationUuid } = loginData;
        try {
            const impact = await getIndicatorLevelNs(frameworkSuite, frameworkId, indicatorUUID, accessToken);

            const impactWithImages = await Promise.all(impact.map(async (item) => {
                const parentLevelNsIds = getParentLevelNsIds(item.levelN_ItemId);
                const topParent = parentLevelNsIds[0];
                const imagePath = imageLabel ?
                    await getLevelNImagePathWithAPIKey(frameworkSuite, frameworkId, topParent, null, imageLabel) :
                    null;
                return {
                    frameworkId: item.frameworkId,
                    levelN_ItemId: item.levelN_ItemId,
                    indicatorUUID: indicatorUUID,
                    organizationUUID: loggedOrganizationUuid,
                    ...(imagePath && { imagePath }),
                };
            }));
            const sorted = impactWithImages.sort((a, b) => {
                if (a.frameworkId === b.frameworkId) {
                    return a.levelN_ItemId - b.levelN_ItemId;
                }
                return a.frameworkId - b.frameworkId;
            });
            return sorted;

        } catch (error) {
            console.error('Error fetching indicator impact:', error);
            showNotification(setNotification, t('Error fetching indicator impact: ') + error.message, 'error', 5000);
            throw error;
        }
    }

    const { data: indicatorImpact, isLoading: isSearching } = useQuery({
        queryKey: ['indicatorImpact', frameworkSuite, frameworkId, indicatorUUID, imageLabel],
        queryFn: () => fetchIndicatorImpact(),
        cacheTime: 180000,
        enabled: !!indicatorUUID,
    });

    const clearCache = () => {
        // console.log('clearCache', ['indicatorImpact', frameworkSuite, frameworkId, indicatorUUID]);
        // listQueriesInCache();
        queryClient.removeQueries({
            // queryKey: ['indicatorImpact', frameworkSuite, frameworkId, indicatorUUID, imageLabel],
            queryKey: ['indicatorImpact'],
            exact: false,
        });
        // listQueriesInCache();
    };

    // to debug queries in cache
    // const listQueriesInCache = () => {
    //     const queries = queryClient.getQueryCache().getAll();
    //     console.log('Queries in cache:', queries);
    // };

    return { indicatorImpact, isSearching, clearCache };
}

export default useIndicatorImpact;